import { Column, Index } from 'typeorm';

import { IsBoolean, IsNumber, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index('games__game__slug', ['slug'], {
  unique: true,
  where: '"deletedAt" is NULL',
})
export class GameBase extends BasicEntity {
  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  name: string;

  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  entryFee: number;

  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  image: string;

  @IsString()
  @Column({ type: 'varchar', nullable: false })
  slug: string;

  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  description: string;

  @IsString()
  @Column({ type: 'text', nullable: false, default: '' })
  rules: string;

  @IsBoolean()
  @Column({ type: 'boolean', default: true })
  isActive: boolean;
}
